// extracted by mini-css-extract-plugin
export default {"panel":"ProfileUpdates_panel__ny8r-","check":"ProfileUpdates_check__9eDTU"};